import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TreeComponent} from "@Common/widgets/general/tree-extended/tree/tree.component";
import {MatTreeModule} from "@angular/material/tree";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";


@NgModule({
  declarations: [
    TreeComponent
  ],
  imports: [
    CommonModule,
    MatTreeModule,
    MatButtonModule,
    MatIconModule,
  ],
  exports: [
    TreeComponent,
  ]
})
export class TreeExtendedModule { }
